import * as React from 'react'

import { cn } from '@/lib/utils'

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
	({ className, type, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					'border-input bg-card text-foreground flex h-10 w-full rounded-lg border px-3 py-2 text-sm shadow-sm transition-colors',
					'file:text-foreground file:border-0 file:bg-transparent file:text-sm file:font-medium',
					'placeholder:text-muted-foreground',
					'focus-visible:ring-ring focus-visible:border-ring focus-visible:ring-1 focus-visible:outline-none',
					'disabled:cursor-not-allowed disabled:opacity-50',
					'md:text-sm',
					className
				)}
				ref={ref}
				{...props}
			/>
		)
	}
)
Input.displayName = 'Input'

export { Input }
